document.addEventListener("DOMContentLoaded", () => {
  // Function to initialize a Splide slider with custom pagination
  function initHelpAndAdviceSlider(slider) {
    const slides = slider.querySelectorAll(".help-and-advice-slide");
    const numberOfSlides = slides.length;

    const paginationContainer = slider.querySelector(
      ".splide-custom-pagination"
    );

    // Create prev/next buttons
    const prevButton = document.createElement("button");
    prevButton.classList.add("splide-custom-prev");
    prevButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><g clip-path="url(#a)"><path stroke="#1C1C1B" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M22.931 2.668 9.598 16 22.93 29.334"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 32V0h32v32z"/></clipPath></defs></svg>'; // Or use an icon

    const nextButton = document.createElement("button");
    nextButton.classList.add("splide-custom-next");
    nextButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><path stroke="#1C1C1B" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M9.065 29.332 22.398 16 9.065 2.666"/></svg>'; // Or use an icon

    paginationContainer.addEventListener("click", (event) => {
      const clickedElement = event.target;
      console.log(clickedElement);
      if (clickedElement.classList.contains("splide-custom-prev")) {
        splide.go("<");
      } else if (clickedElement.classList.contains("splide-custom-next")) {
        splide.go(">");
      }
    });

    const splide = new Splide(slider, {
      type: numberOfSlides > 3 ? "loop" : "slide",
      perPage: 1,
      perMove: 1,
      gap: "16px",
      focus: "left",
      rewind: true,
      arrows: false,
      pagination: false,
      mediaQuery: "min",
      breakpoints: {
        768: {
          perPage: Math.min(numberOfSlides, 3),
        },
        992: {
          gap: "24px",
        },
        1920: {
          gap: "32px",
        },
      },
    });

    function updatePagination() {
      paginationContainer.innerHTML = "";
      const totalPages = Math.ceil(numberOfSlides / splide.options.perPage);

      paginationContainer.appendChild(prevButton);

      for (let i = 0; i < totalPages; i++) {
        const button = document.createElement("button");
        button.textContent = i + 1;
        button.addEventListener("click", () => {
          splide.go(i * splide.options.perPage);
        });

        button.classList.toggle("active", i === Math.floor(splide.index));

        paginationContainer.appendChild(button);
      }

      paginationContainer.appendChild(nextButton);
    }

    // Event listeners for updating pagination
    splide.on("move", updatePagination);
    splide.on("resized", updatePagination);

    splide.mount();
    updatePagination(); // Initial pagination setup
  }

  // Initialize all sliders on the page
  const helpAndAdviceSliders = document.querySelectorAll(
    "#help-and-advice-block-slider"
  );
  helpAndAdviceSliders.forEach(initHelpAndAdviceSlider);
});
